import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { FiCheckCircle, FiRefreshCw } from 'react-icons/fi';
import { useAuth } from '../hooks/useAuth';

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const { refreshUser } = useAuth();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Refresh user data to get updated subscription info
    if (sessionId) {
      setTimeout(() => {
        refreshUser();
      }, 2000); // Give webhook time to process
    }
  }, [sessionId, refreshUser]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh', 
      flexDirection: 'column', 
      backgroundColor: '#f9fafb',
      padding: '20px'
    }}>
      <FiCheckCircle size={80} color="#10b981" />
      <h1 style={{ fontSize: '2.5rem', margin: '20px 0', textAlign: 'center' }}>Payment Successful!</h1>
      <p style={{ fontSize: '1.2rem', color: '#6b7280', marginBottom: '30px', textAlign: 'center', maxWidth: '500px' }}>
        Thank you for your purchase! Your subscription has been activated and you now have access to all premium features.
      </p>
      <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
        <Link 
          to="/dashboard" 
          style={{ 
            padding: '12px 24px', 
            backgroundColor: '#FF9900', 
            color: 'white', 
            textDecoration: 'none', 
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontWeight: '600'
          }}
        >
          <FiRefreshCw size={16} />
        Go to Dashboard
      </Link>
        <Link 
          to="/" 
          style={{ 
            padding: '12px 24px', 
            backgroundColor: '#6b7280', 
            color: 'white', 
            textDecoration: 'none', 
            borderRadius: '8px',
            fontWeight: '600'
          }}
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default SuccessPage; 